module.exports = __webpack_public_path__ + "static/img/login-register-img.417b0fe4.png";